import { FormattedMessage } from "react-intl";
import classNames from "classnames";

// Styles
import tableStyles from "./../../../theme/table.module.css";
import styles from "./styles.module.css";

// Utils
import { contactAdapter } from "./../../../utils/contacts";

// Components
import ContactPlatform from "../../common/contact-platform";
import { Settings } from "../../../interfaces";

const LeadsTable = (props: {
  leadsTotal: any;
  leads: any;
  settings: Settings;
  handleClick: (id: string) => void;
}) => {
  const { leadsTotal, leads, settings, handleClick } = props;
  const { companies } = settings;
  return (
    <div className={`${tableStyles.tableContainer} ${styles.tableContainer}`}>
      <table className="table mb-0">
        <thead className={tableStyles.theadFixed}>
          <tr className={tableStyles.tableHeader}>
            <th className={`${tableStyles.tableTitle}  ${styles.date}`}>
              <FormattedMessage id="leads.date" />
            </th>
            <th className={`${tableStyles.tableTitle}  ${styles.date}`}>
              <FormattedMessage id="leads.score" />
            </th>
            {companies.length > 1 && (
              <th className={tableStyles.tableTitle}>
                <FormattedMessage id="common.company" />
              </th>
            )}
            <th className={tableStyles.tableTitle}>
              <FormattedMessage id="common.name" />
            </th>
            <th className={tableStyles.tableTitle}></th>
            {leadsTotal?.actions.map((r: any) => (
              <th className={tableStyles.tableTitle} key={r.name}>
                {" "}
                <FormattedMessage id={`leads.stats.${r.name}`} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={tableStyles.tableBody}>
          {leads?.length === 0 && (
            <tr className="fs-3">
              <td className="text-center" colSpan={9}>
                <FormattedMessage id="common.noResults" />
              </td>
            </tr>
          )}
          {leads.map((o: any) => {
            const contact = contactAdapter(o, {});
            const { manual, blocked, name, phoneNumber, timestampHour, score } =
              contact;
            return (
              <tr key={o._id} onClick={() => handleClick(o._id)}>
                <td className={`${styles.date} ${tableStyles.tableValue}`}>
                  {timestampHour}
                </td>
                <td className={tableStyles.tableValue}>
                  <span
                    className={classNames("badge", {
                      "text-bg-danger": score === 1,
                      "text-bg-warning": score === 2 || score === 3,
                      "text-bg-light": score === 4 || score === 5 || !score,
                    })}
                  >
                    {score || 5}
                  </span>
                </td>
                {props.settings.companies.length > 1 && (
                  <td className={tableStyles.tableValue}>
                    {o.companies.map((c: any) => c.name)}
                  </td>
                )}
                <td className={tableStyles.tableValue}>
                  <div className="flex gap-2 align-items-center">
                    <div>
                      <span>{name || phoneNumber}</span>
                    </div>
                  </div>
                </td>
                <td className={tableStyles.tableValue}>
                  <div className="flex gap-1">
                    {o.escalated ? (
                      <div className="badge text-bg-warning">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="fw-semibold-1">
                            <FormattedMessage id="esc.needsReview" />
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {manual ? (
                      <div className="badge text-bg-info">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="fw-semibold-1">
                            <FormattedMessage id="chats.manual" />
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {blocked ? (
                      <div className="badge text-bg-danger">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="fw-semibold-1">
                            <FormattedMessage id="chats.blocked" />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </td>
                {leadsTotal?.actions.map((r: any) => (
                  <td className={tableStyles.tableValue} key={r.name}>
                    {o.actions && o.actions.some((a: any) => a === r.name) ? (
                      <span className="badge text-bg-light">
                        <FormattedMessage id="common.yes" />
                      </span>
                    ) : null}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LeadsTable;
